import React from 'react'
import Loader from 'components/common/atoms/Loader'
import times from 'lodash/times'

export const TitlePopTermsSkeleton = () => {
  return (
    <div>
      <Loader
        dataTestId="kampuspedia-pop-terms-title"
        className="kampuspedia-pop-terms__title"
        width="inherit"
        customSize={{
          sp: {
            width: 360,
            height: 24,
            borderRadius: 10,
          },
          pc: {
            width: 300,
            height: 24,
            borderRadius: 10,
          },
        }}
      />
    </div>
  )
}

export const TermsSkeleton = () => {
  return (
    <>
      {times(5, (i) => (
        <Loader
          key={`kampuspedia-pop-terms__term-${i}`}
          dataTestId={`kampuspedia-pop-terms__term-${i}`}
          customSize={{
            sp: {
              width: 90,
              height: 24,
              borderRadius: 10,
            },
            pc: {
              width: 120,
              height: 40,
              borderRadius: 10,
            },
          }}
        />
      ))}
    </>
  )
}
